import { useEffect, useState } from 'react';
import { Chart as ChartJS } from 'chart.js';
import { themes, hexToRgba } from '../data/themes';

export default function useTheme() {
  const [theme, setTheme] = useState(() => localStorage.getItem('renx-theme') || 'renx');

  useEffect(() => {
    const t = themes.find(x => x.id === theme);
    if (!t) return;

    const root = document.documentElement;
    root.style.setProperty('--black', t.bg1);
    root.style.setProperty('--black-2', t.bg2);
    root.style.setProperty('--black-3', t.bg3);
    root.style.setProperty('--gold', t.accent);
    root.style.setProperty('--gold-light', t.accentLight);
    root.style.setProperty('--gold-dim', t.accentDim);
    root.style.setProperty('--text-primary', t.text1);
    root.style.setProperty('--text-secondary', t.text2);
    root.style.setProperty('--text-muted', t.text3);
    root.style.setProperty('--gold-glow', hexToRgba(t.accent, 0.15));
    root.style.setProperty('--gold-glow-strong', hexToRgba(t.accent, 0.35));
    root.style.setProperty('--glass', t.isLight ? 'rgba(0,0,0,0.03)' : 'rgba(255,255,255,0.03)');
    root.style.setProperty('--glass-strong', t.isLight ? 'rgba(0,0,0,0.06)' : 'rgba(255,255,255,0.06)');
    root.style.setProperty('--glass-border', hexToRgba(t.accent, 0.15));
    root.style.setProperty('--glass-border-hover', hexToRgba(t.accent, 0.4));
    root.style.setProperty('--black-alpha-80', hexToRgba(t.bg1, 0.8));
    root.style.setProperty('--black-alpha-95', hexToRgba(t.bg3, 0.95));
    root.style.setProperty('--black-alpha-98', hexToRgba(t.bg1, 0.98));
    root.style.setProperty('--black2-alpha-98', hexToRgba(t.bg2, 0.98));

    if (t.isLight) document.body.classList.add('light-theme');
    else document.body.classList.remove('light-theme');

    ChartJS.defaults.color = t.text2;
    localStorage.setItem('renx-theme', theme);
  }, [theme]);

  return [theme, setTheme];
}
